<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="TIT"><span epub:type="pagebreak" id="pg_iii" title="iii"><img alt="image" height="800" src="images/69994_ch00_3P_fmt.jpeg" width="533"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?349dddf6